export default function VisionSlide() {
  return (
    <div className="max-w-5xl w-full mx-auto relative z-10 flex flex-col items-center justify-center gap-8">
      <div className="text-center">
        <h2 className="font-display text-7xl">What is Avo Today?</h2>
      </div>

      {/* Browser chrome video window */}
      <div className="relative w-full group">
        {/* Ambient glow */}
        <div className="absolute -inset-4 bg-gradient-to-br from-avo-purple/30 via-avo-lime/10 to-avo-cyan/20 rounded-[36px] blur-2xl opacity-60" />

        {/* Glow border */}
        <div
          className="absolute -inset-px bg-gradient-to-br from-avo-lime/40 via-avo-purple/30 to-avo-cyan/40 rounded-3xl"
          style={{ filter: "blur(1px)" }}
        />

        <div className="relative bg-[#151518] rounded-3xl border border-white/10 overflow-hidden shadow-[0_30px_80px_rgba(0,0,0,0.6)]">
          {/* Browser chrome */}
          <div className="h-10 bg-[#0E0E11] border-b border-white/5 flex items-center px-4 gap-4">
            {/* Traffic light buttons */}
            <div className="flex gap-2">
              <div className="w-3 h-3 rounded-full bg-[#FF5F56]" />
              <div className="w-3 h-3 rounded-full bg-[#FFBD2E]" />
              <div className="w-3 h-3 rounded-full bg-[#27C93F]" />
            </div>

            {/* URL bar */}
            <div className="flex-1 flex justify-center">
              <div className="bg-white/5 px-4 py-1 rounded-md flex items-center gap-2 text-xs text-gray-400 font-mono">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-3 h-3 text-gray-500"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
                app.avo.so
              </div>
            </div>
            <div className="w-16" />
          </div>

          {/* Video */}
          <div className="aspect-video w-full bg-black">
            <iframe
              src="https://www.tella.tv/video/avo-platform-demo-copy-4tpq/embed?b=0&title=0&a=1&loop=0&t=0&muted=0&wt=0&o=1&speed=1.2"
              title="Avo Platform Demo"
              className="w-full h-full"
              style={{ overflow: "hidden", border: 0, display: "block" }}
              scrolling="no"
              allow="encrypted-media; picture-in-picture"
              allowFullScreen
              allowTransparency
            />
          </div>
        </div>
      </div>
    </div>
  );
}
